import React, { useMemo } from 'react'

import { useTranslation } from 'language/translator'
import { useDashboardExamples } from 'redux/hooks/DashboardExamples'

import Box from 'components_new/atoms/Box'

import ChipTabs from 'components_new/molecules/ChipTabs'
import SelectButton from 'components_new/molecules/SelectButton'

import StandardSearch from 'components_new/organisms/StandardSearch'

import { sortAlphabeticalAsc } from 'utils/sortHelper'

import Loading from './loading'

import {
  getUniqueCategories,
  getUniqueSegments
} from '../DashboardExampleExplorer/utils'

interface DashboardExampleFilterMenuProps {
  category: string | null
  search: string
  segment: string | null
  setCategory: (category: string | null) => void
  setSearch: (value: string) => void
  setSegment: (value: string | null) => void
  sx?: object
}

const DashboardExampleFilterMenu = (props: DashboardExampleFilterMenuProps) => {
  const { category, search, segment, setCategory, setSearch, setSegment, sx } =
    props

  const { lang, t } = useTranslation()
  const dashboardExamples = useDashboardExamples()

  /*-- categories --*/
  const categoryOptions = useMemo(
    () =>
      getUniqueCategories(Object.values(dashboardExamples), lang).sort((a, b) =>
        sortAlphabeticalAsc(a.label, b.label)
      ),
    [dashboardExamples, lang]
  )

  /* -- segments -- */
  const segmentOptions = useMemo(
    () =>
      getUniqueSegments(Object.values(dashboardExamples), lang).sort((a, b) =>
        sortAlphabeticalAsc(a.title, b.title)
      ),
    [dashboardExamples, lang]
  )

  // loading
  if (!dashboardExamples) return <Loading />

  // success
  return (
    <Box sx={sx}>
      <StandardSearch
        debounce={true}
        fullWidth={true}
        search={search}
        setSearch={(value) => setSearch(value ?? '')}
        sx={{ mb: 1 }}
      />

      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <ChipTabs
          onChange={(value) => setCategory(value)}
          options={categoryOptions}
          size="small"
          sx={{ flex: 1 }}
          value={category}
        />

        <SelectButton
          showActive={true}
          onChange={(value) => setSegment(value)}
          options={[
            {
              id: null,
              title: t('global', 'all_company_types')
            },
            ...segmentOptions
          ]}
          placeholder={t('global', 'all_company_types')}
          value={segment}
        />
      </Box>
    </Box>
  )
}

export default DashboardExampleFilterMenu
